export function StyleItemPromos({ styleItem }) {
  return styleItem.promos.map(promo => {
    let style = {};
    if (promo.color) {
      style.color = promo.color;
    }
    return (
      <div className="style-item-promo__wrapper" key={promo.icon_class + "-" + promo.text}>
        <span className="style-item-promo__icon">
            <i className={`icon icon-${promo.icon_class}`}></i>
        </span>
        <span className="style-item-promo__text" style={style}>
            {promo.text}
        </span>
      </div>
    )
  })
}
